export default "__VITE_ASSET__7508b581__"